import { createSlice } from "@reduxjs/toolkit";

export const UserSlice = createSlice({
  name: "user",
  initialState: {
    isFetching: false,
    redirectUrl:"",
    isUserLoggedIn: false,
    userInfo: JSON.parse(localStorage.getItem("userinfo")) || {
      userId: "",
      userName: "",
      email: "",
      Country: "",
      accountId: "",
      product_contractId: "",
      commercial_contractId: "",
    },
    userEmail: "",
    showLogin: false,
    callBack: null,
    invalidUser: "",
    userFullDetails: {},
  },
  reducers: {
    setRedirectUrl: (state, {payload, type}) => {
      state.redirectUrl = payload.redirectUrl;
    },

    validateUser: (state) => {
      state.isFetching = true;
    },
    setIsUserLoggedIn: (state, { payload, type }) => {
      state.isFetching = false;
      state.isUserLoggedIn = payload;
      state.invalidUser = "";
    },
    getUserInfo: (state) => {
      state.isFetching = true;
    },
    setUserInfo: (state, { payload, type }) => {
      state.isFetching = false;

      // The saga dispatches a single user row; tolerate a wrapping array too.
      // Everything downstream reads userInfo as a flat object (userinfo?.accountId).
      const user = Array.isArray(payload) ? payload[0] : payload;

      if (user?.email) {
        // Signing in as a different user must not leave the previous account's
        // details in place - they carry the accountId every farm read is keyed on.
        if (state.userFullDetails?.email && state.userFullDetails.email !== user.email) {
          state.userFullDetails = {};
        }
        state.userInfo = user;
        state.userEmail = user.email;
      } else {
        state.userInfo = {
          userId: "",
          userName: "",
          email: "",
          Country: "",
          accountId: "",
          product_contractId: "",
          commercial_contractId: "",
        };
        state.userEmail = "";
        state.userFullDetails = {};
      }
      state.invalidUser = "";
    },
    setShowLogin: (state, { payload, type }) => {
      state.showLogin = payload.value;
      state.callBack = payload.cb;      
    },
    logout: (state) => {
      state.isFetching = false;
      state.isUserLoggedIn = false;
      state.userInfo = {
        userId: "",
        userName: "",
        email: "",
        Country: "",
        accountId: "",
        product_contractId: "",
        commercial_contractId: "",
      };
      state.userEmail = "";
      // Must be cleared: it holds the accountId that farm/profile reads use, so
      // leaving it behind shows the previous user's data to the next one.
      state.userFullDetails = {};
      state.invalidUser = "";
    },
    setInValidUser: (state, { payload, type }) => {
      state.invalidUser = payload;
      state.isFetching = false;
    },
    getUserFullDetails: (state, { payload, type }) => {
      state.isFetching = true;
      state.isSuccess = false;
      state.userFullDetails = payload;
    },
    setUserFullDetails: (state, { payload, type }) => {
      state.isFetching = false;
      state.isSuccess = false;
      state.userFullDetails = payload;
    },
    forgotPassword: (state) => {
      state.isFetching = true;
    },
    setForgotPasswordSuccess: (state, { payload }) => {
      state.isFetching = false;
    },
    setForgotPasswordError: (state, { payload }) => {
      state.isFetching = false;
    },
    verifyResetToken: (state) => {
      state.isFetching = true;
    },
    setVerifyResetTokenSuccess: (state, { payload }) => {
      state.isFetching = false;
    },
    setVerifyResetTokenError: (state, { payload }) => {
      state.isFetching = false;
    },
    resetPassword: (state) => {
      state.isFetching = true;
    },
    setResetPasswordSuccess: (state) => {
      state.isFetching = false;
    },
    setResetPasswordError: (state) => {
      state.isFetching = false;
    },
  },
});

export const {
  validateUser,
  setIsUserLoggedIn,
  getUserInfo,
  setUserInfo,
  logout,
  setShowLogin,
  setRedirectUrl,
  resetShowSuccessMessage,
  setInValidUser,
  getUserFullDetails,
  setUserFullDetails,
  forgotPassword,
  setForgotPasswordSuccess,
  setForgotPasswordError,
  verifyResetToken,
  setVerifyResetTokenSuccess,
  setVerifyResetTokenError,
  resetPassword,
  setResetPasswordSuccess,
  setResetPasswordError
} = UserSlice.actions;

export default UserSlice.reducer;
